export default ({ color }) => ({
  metricTypeBox: {
    width: 'auto',
    height: 19,
    whiteSpace: 'nowrap',
    padding: '8px 0 8px 0',
    display: 'inline-block',
    borderRadius: 5,
    justifyContent: 'center',
    alignItems: 'center',
    color: color.accent,
  },
  filterLabelForName: {
    display: 'inline-block',
  },
  td: {
    border: '0!important',
  },
  filterLabelContainer: {
    position: 'relative',
    width: 'auto',
    background: color.white,
    color: color.accent,
    height: 'auto',
    cursor: 'pointer',
    padding: 8,
    borderRadius: 5,
    marginBottom: 10,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginRight: 18,
    marginLeft: 10,
  },
  table: {
    boxShadow: 'none!important',
  },
  tableData: {
    border: 'none!important',
    padding: '0!important',
  },
  tableElement: {
    padding: '10px 22px 10px 28px !important',
    position: 'relative',
    marginBottom: 15,
    textAlign: 'center',
    borderTop: `1px solid ${color.primaryButtonBackground}`,
    borderBottom: `1px solid ${color.primaryButtonBackground}`,
    color: color.primaryButtonBackground,
    cursor: 'pointer',
  },
  metricCountContainer: {
    borderRadius: '50%',
    width: 18,
    textAlign: 'center',
    display: 'inline-block',
    border: `1px solid ${color.primaryButtonBackground}`,
    background: color.primaryButtonBackground,
    color: color.white,
    marginLeft: 7,
  },
  borderLeft: {
    borderLeft: `1px solid ${color.primaryButtonBackground}`,
    borderTopLeftRadius: 5,
    borderBottomLeftRadius: 5,
  },
  borderRight: {
    borderRight: `1px solid ${color.primaryButtonBackground}`,
    borderTopRightRadius: 5,
    borderBottomRightRadius: 5,
  },
  arrow: {
    padding: 15,
    display: 'inline',
    position: 'absolute',
    left: '-15px',
    bottom: 5,
    border: `1px solid ${color.primaryButtonBackground}`,
    borderLeft: 'transparent',
    borderBottom: 'transparent',
    transform: 'rotate(45deg)',
  },
});
